import React from 'react';
import SeoLandingPage, { SeoLandingContent } from './SeoLandingPage';

const content: SeoLandingContent = {
  path: '/lawn-care-crm',
  title: 'Lawn Care CRM Software | LawnHub',
  description:
    'Lawn care CRM to manage customers, services, payments, and follow-ups in one place. Built for lawn and snow businesses that want ops tools without forced monthly fees.',
  keywords:
    'lawn care CRM, landscaping CRM, lawn care customer management, snow removal CRM, lawn business software CRM',
  h1: 'Lawn Care CRM Built for Real Field Businesses',
  subhead:
    'Keep every customer, property, schedule, and payment in one system — so renewals, crew notes, and service history are never buried in texts or spreadsheets.',
  sections: [
    {
      heading: 'Your customer book, organized',
      body: 'A lawn care CRM should match how you actually work: multiple properties, seasonal contracts, add-on jobs, and family accounts. LawnHub stores customers and service context where your schedule and payments already live.',
      bullets: [
        'Onboard existing customers and keep the relationship yours',
        'Track services, notes, and history per property',
        'Send Additional Services estimates (cleanup, aeration, and more)',
        'Stay on top of renewals instead of starting from scratch each season',
      ],
    },
    {
      heading: 'CRM that connects to money and crews',
      body: 'Contact records alone do not run a lawn company. LawnHub ties CRM to scheduling, route optimization, crew tools, and automated payments so office and field stay in sync.',
      bullets: [
        'See who is scheduled and what they owe in one workflow',
        'Financial Dashboard for revenue and expenses',
        'Optional crew productivity and payroll-ready export',
        'Reviews and documentation to protect quality',
      ],
    },
    {
      heading: 'Grow without giving away the margin',
      body: 'Bring your own customers onto LawnHub at a 1% platform fee on completed jobs. Use marketplace leads when you want new business. No forced subscription just to access your CRM.',
    },
  ],
  faq: [
    {
      q: 'Can I import or onboard my existing lawn care customers?',
      a: 'Yes. Providers can bring existing customers onto LawnHub and manage them with CRM, scheduling, and payments — typically at a 1% fee when jobs are completed.',
    },
    {
      q: 'Is LawnHub only a CRM?',
      a: 'No. CRM is part of a full ops platform: scheduling, crews, routes, payments, financial reporting, and optional marketplace leads.',
    },
    {
      q: 'Do I pay a monthly CRM subscription?',
      a: 'LawnHub does not force a monthly subscription to manage your customers. You pay platform fees when jobs are completed (1–5% depending on customer source).',
    },
  ],
  relatedLinks: [
    { label: 'Lawn care scheduling software', to: '/lawn-care-scheduling-software' },
    { label: 'Jobber alternative', to: '/jobber-alternative' },
    { label: 'Provider benefits', to: '/provider-benefits' },
    { label: 'Get started free', to: '/get-started' },
  ],
};

const LawnCareCrmPage: React.FC = () => <SeoLandingPage content={content} />;

export default LawnCareCrmPage;
